import type { InputHTMLAttributes } from "react";
import type { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { Checkbox } from "@/components/form/Checkbox";
import { FormField } from "@/components/form/FormField";
import { Label } from "@/components/text/Label";
import { NormalText } from "@/components/text/NormalText";

export function CheckboxField({
  id,
  label,
  description1,
  description2,
  error,
  register,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  id: string;
  label: string;
  description1: string;
  description2: string;
  error: FieldError["message"] | null;
  register: UseFormRegisterReturn | null;
}) {
  return (
    <FormField id={id} label={label} error={error} register={null}>
      <NormalText elementType="p">{description1}</NormalText>
      <div className="flex items-start gap-3">
        <Checkbox
          id={id}
          className="mt-1"
          {...(register === null ? {} : register)}
          {...props}
        />

        <Label
          elementType="label"
          htmlFor={id}
          className="cursor-pointer select-none text-gray-500"
        >
          {description2}
        </Label>
      </div>
    </FormField>
  );
}
